var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { SeeDetailsQuote } from "../../../fnx/seeDetailsQuote";
import newExcel from "../../../assets/images/newExcel.svg";
import { hasAuditRole, hasPermission, } from "../../../services/getNavigationPages";
export var NodeType;
(function (NodeType) {
    NodeType["Screen"] = "screen";
    NodeType["Conditional"] = "conditional";
    NodeType["ConditionalRequired"] = "conditionalrequired";
    NodeType["Api"] = "api";
    NodeType["Property"] = "property";
    NodeType["LocalStorage"] = "localstorage";
    NodeType["Next"] = "next";
    NodeType["Previous"] = "previous";
    NodeType["Success"] = "success";
    NodeType["Error"] = "error";
    NodeType["Start"] = "start";
    NodeType["End"] = "end";
    NodeType["Input"] = "input";
})(NodeType || (NodeType = {}));
var handleClickContextMenu = function (item, params, handleDelete) {
    switch (item.id) {
        case "1":
            handleDelete(params);
            break;
        case "2":
            SeeDetailsQuote(params);
            break;
        default:
            break;
    }
};
export var getColumnsHistory = [
    {
        field: "fechaCarga",
        headerName: "Fecha Carga",
        width: 170,
    },
    {
        field: "usuario",
        headerName: "Usuario",
        width: 270,
    },
    {
        field: "movimiento",
        headerName: "Movimiento",
        width: 170,
    },
    {
        field: "comentario",
        headerName: "Comentario",
        width: 350,
    },
];
export var columns = function (handleClickContextMenu) { return [
    {
        field: "actions",
        headerName: "Acciones",
        width: 120,
        renderCell: function (params) {
            var isSinDocument = params.row.code !== "AFU";
            var isStatusEmitida = params.row.status === "Emitida" || isSinDocument;
            if (hasAuditRole()) {
                isStatusEmitida = false;
            }
            var menuContext = [
                {
                    disabled: isStatusEmitida,
                    icon: {
                        color: "#006ac6",
                        icon: icons.UploadFile,
                        size: sizesIcon.standard,
                    },
                    id: "3",
                    name: "Fiscalizar",
                },
                {
                    disabled: !hasPermission("sale-policies-sumary-see-detail"),
                    icon: {
                        color: "#006ac6",
                        icon: icons.Search,
                        size: sizesIcon.standard,
                    },
                    id: "2",
                    name: "Ver detalles",
                },
                {
                    disabled: !hasPermission("sale-policies-sumary-cancel") ||
                        params.row.status === "Cancelada",
                    icon: {
                        color: params.row.status === "Cancelada" ||
                            params.row.status === "cancelada" ||
                            params.row.status === "Expirada" ||
                            params.row.status === "expirada"
                            ? "#cccccc"
                            : "#d32f2f",
                        icon: icons.Cancel,
                        size: sizesIcon.standard,
                    },
                    id: "1",
                    name: "Cancelar",
                },
                {
                    disabled: false,
                    icon: {
                        color: "#006ac6",
                        icon: icons.GridView,
                        size: sizesIcon.standard,
                    },
                    id: "4",
                    name: "Historial",
                },
            ];
            if (params.row.status === "Pendiente" &&
                (params.row.code === "SPR" || params.row.code === "NPR")) {
                menuContext.push({
                    disabled: !hasPermission("admin-activate-policy"),
                    icon: {
                        color: "#006ac6",
                        icon: icons.CheckCircle,
                        size: sizesIcon.standard,
                    },
                    id: "5",
                    name: "Finalizar Venta",
                });
            }
            var menuContextV = isSinDocument ? menuContext.slice(1) : menuContext;
            return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: menuContextV, onClickContextMenu: function (item) {
                        return handleClickContextMenu(item, params);
                    }, sizeIcon: sizesIcon.standard }) })));
        },
    },
    {
        editable: false,
        field: "status",
        headerName: "Estado",
        renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx("span", { className: params.value }), params.value] }))); },
        width: 100,
    },
    {
        field: "quotation",
        headerName: "Cotización",
        width: 170,
    },
    {
        field: "certificate",
        headerName: "No. Póliza",
        width: 170,
    },
    {
        field: "firstNameA",
        headerName: "Nombres",
        width: 250,
    },
    {
        field: "lastNameA",
        headerName: "Primer apellido",
        width: 170,
    },
    {
        field: "lastNameB",
        headerName: "Segundo apellido",
        width: 170,
    },
    {
        field: "identification",
        headerName: "Identificación",
        width: 150,
    },
    {
        field: "branch",
        headerName: "Sucursal",
        width: 150,
    },
    {
        field: "user",
        headerName: "Usuario",
        width: 175,
    },
    {
        field: "product",
        headerName: "Producto",
        width: 175,
    },
    {
        field: "insuranceCarrier",
        headerName: "Aseguradora",
        width: 175,
    },
    {
        field: "cancellationDate",
        headerName: "Fecha de cancelación",
        width: 170,
    },
    {
        field: "reasonCancellation",
        headerName: "Motivo de cancelación",
        width: 170,
    },
]; };
export var getFilters = function (insuranceOptions, statusOptions, branchOptions) { return [
    {
        active: true,
        backgroundColor: "#E8EEFF",
        border: true,
        borderRadius: "8px",
        borderType: "1px solid #96ABFF",
        color: "#0D1BD9",
        sizes: "40px",
        type: "fullTextSearch",
    },
    {
        backgroundColor: "#f5f7fa",
        color: "#3a56a1",
        fontWeight: 700,
        label: "Limpiar Filtros",
        type: "cleanButton",
        variantButtons: variants.contained,
        visible: true,
    },
    {
        disabled: !hasPermission("sale-policies-sumary-export"),
        label: "Exportar",
        listButtonDropdown: [
            {
                icons: icons.DownloadForOffline,
                id: "1",
                img: newExcel,
                name: "Descargar Excel",
            },
        ],
        showImage: true,
        type: "exportButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        id: "dateRange",
        label: "Rango de fechas",
        type: "dateRange",
    },
    {
        backgroundColor: "#3A56A1",
        color: "#FFFFFF",
        id: "insurance",
        initialSelected: 4,
        listAvatar: insuranceOptions,
        surplus: 2,
        type: "avatarSelection",
        width: "225px",
    },
    {
        dropdownIndex: 1,
        id: "state",
        label: "Estado",
        listDropDown: statusOptions,
        titleSearch: "Buscar",
        allChecked: false,
        type: "dropdownMultiple",
        border: true,
        borderRadius: "8px",
    },
    {
        dropdownIndex: 2,
        id: "branchs",
        label: "Sucursales",
        allChecked: false,
        listDropDown: branchOptions,
        titleSearch: "Buscar",
        type: "dropdownMultiple",
        border: true,
        borderRadius: "8px",
    },
]; };
